import css from "./ProfLink.module.css";
import { Link } from "react-router";
import { useTurl } from "~/util/Lang";
import { Icon, Icon32 } from "../ui/Icon";

export type ProfLinkData = {
  profName: string;
  name: string;
};

export function ProfLink(props: {
  data: ProfLinkData;
  iconSize?: 16 | 24 | 32;
  showIcon?: boolean;
}) {
  const turl = useTurl();
  const data = props.data;
  const iconSize = props.iconSize ?? 16;
  const showIcon = props.showIcon ?? true;

  return (
    <Link to={turl(`/classes/${data.profName}`)} className={css.link}>
      {showIcon && (
        <span
          className={css.icon}
          style={{ marginRight: iconSize === 16 ? 3 : 9 }}
        >
          {iconSize !== 32 ? (
            <Icon
              icon={data.profName}
              size={iconSize}
              alt={`Icon Class ${data.name}`}
            />
          ) : (
            <Icon32 icon={data.profName} alt={`Icon Class ${data.name}`} />
          )}
        </span>
      )}
      <span className={css.name}>{data.name}</span>
    </Link>
  );
}
